import { handleNavigationMenu } from "../../../js/utils";

(() => {
  const BRHHeader = () => {
    const init = () => {
      const burger = document.querySelector(".js-burger");
      const headerMenu = document.querySelector(".js-header-menu");
      const body = document.body;
      burger?.addEventListener("click", () => {
        if (burger) {
          burger.classList.toggle("mod--menu-open");
          headerMenu.classList.toggle("mod--menu-open");
          body.classList.toggle("mod--menu-open");
          if (burger.classList.contains("mod--submenu-open")) {
            burger.classList.toggle("mod--submenu-open");
            const openItemsClass = ".js-navigation-menu.mod--submenu-open";
            handleNavigationMenu(openItemsClass);
          }
        }
      });
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHHeader);

  const header = document.querySelector(".brh-header");
  const toggleClass = "is-sticky";
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 10) {
      header.classList.add(toggleClass);
    } else {
      header.classList.remove(toggleClass);
    }
  });
})();
